import { MenuData } from 'tiptap';
import TurndownService from 'turndown';
import { Remarkable } from 'remarkable';

export const globalState: IGlobalState = {
  editor: null,
  editorContentHtml: '',
  isEmpty: true,
} as any;

export interface IGlobalState {
  editor: MenuData['editor'];
  editorContentHtml: string;
  isEmpty: boolean;
}

export const convertHTMLToMarkdown = (html: string) => {
  const turndownService = new TurndownService({ headingStyle: 'atx', codeBlockStyle: 'fenced' });
  const markdown = turndownService.turndown(html);
  return markdown;
};

export const convertMarkdownToHTML = (markdown: string) => {
  const remarkService = new Remarkable();
  const html = remarkService.render(markdown);
  return html;
};
